export const TASK_TYPE_DATA = {
  1: "视频发布数",
  2: "直播场次",
  3: "累计视频播放量",
  4: "直播观看量",
  5: "活动模版视频数",
  6: "播放≥500视频数",
  7: "时长≥30min直播场次",
  8: "播放≥500活动模板视频数",
  9: "时长≥60min直播场次",
  10: "时长≥90min直播场次",
  11: "时长≥120min直播场次",
  12: "任意模版视频数",
  13: "播放≥500任意模板视频数",
  14: "笔记发布数",
  15: "图文笔记发布数",
  16: "视频笔记发布数",
  17: "直播时长(min)",
};
